module.exports = __webpack_public_path__ + "assets/img/service_b1.7701a13d.png";